import { FecThirdPartyFilter } from '../enums/fecThirdPartyFilter'

export const isFecThirdPartyFilter = (value: string): value is FecThirdPartyFilter =>
  Object.values<string>(FecThirdPartyFilter).includes(value)
